import { Action } from 'redux';
import { Channel } from '@dev/ee-api/ee-api-models';

export enum ChannelsActionTypes {
    LOAD_ALL = '@@channels/LOAD_ALL',
    LOAD_ALL_SUCCESS = '@@channels/LOAD_ALL_SUCCESS',
    LOAD_ALL_ERROR = '@@channels/LOAD_ALL_ERROR',
}

export interface ChannelsPayload {
    search?: string;
    activePage?: number;
    offset?: number;
    limit?: number;
    perPage?: number;
    skipSagaURL?: boolean;
}
export interface LoadChannelsStartAction extends Action {
    type: ChannelsActionTypes.LOAD_ALL;
    payload: ChannelsPayload;
}
export interface LoadChannelsSuccessAction extends Action {
    type: ChannelsActionTypes.LOAD_ALL_SUCCESS;
    payload: StatisticsChannelsState;
}
export interface LoadChannelsErrorAction extends Action {
    type: ChannelsActionTypes.LOAD_ALL_ERROR;
    payload: {
        loading: boolean;
    };
}

export interface StatisticsChannelsState {
    loading?: boolean;
    channels?: Channel[];
    singleChannel?: Channel;
    singleChannelLoading?: boolean;
    totalCount?: number;
    activePage?: number;
    search?: string;
    perPage: number;
}
